import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {currentUserIsAdmin} from '@netx/core-permissions-next/enablers/currentUserIsAdmin';
import {permissionsEnabled} from '@netx/core-permissions-next/enablers';
import {DataSetPref} from '../constants';

/** Is the user above the min user level? */
export const datamanagerAuthorized = () =>
	permissionsEnabled()
		? currentUserIsAdmin()
		: currentUserMeetsUserLevel(
				parseInt(getPreference(DataSetPref.MIN_USER_LEVEL) || '') ||
					UserLevel.MANAGER,
			);
